import React from 'react'
import { useParams } from 'react-router-dom'
import { Grid } from '@mui/material'

import { DataBlock, FetchErrorMessage, ViewPaymentSkeleton } from '../../components'
import { useGetAcqPayment } from '../../services'

import { CARD_INFO_LABELS, CLIENT_INFO_LABELS, MAIN_INFO_LABELS, MONEY_INFO_LABELS } from './constants.ts'

export const AcquiringPaymentView = (): React.ReactElement => {
  const { id = '' } = useParams<{ id: string }>()
  const { data, isRefetching, refetch, isError, isLoading } = useGetAcqPayment(id)

  if (!data?.data.id || isLoading) return <ViewPaymentSkeleton />

  return (
    <FetchErrorMessage isFetching={isRefetching} isError={isError} refetch={refetch}>
      <Grid container flexDirection="row" spacing={{ xs: 2, lg: 4 }}>
        <Grid item xs={12} md={6}>
          <DataBlock items={MAIN_INFO_LABELS} data={data.data} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DataBlock items={CLIENT_INFO_LABELS} data={data.data} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DataBlock items={MONEY_INFO_LABELS} data={data.data} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DataBlock items={CARD_INFO_LABELS} data={data.data} />
        </Grid>
      </Grid>
    </FetchErrorMessage>
  )
}
